export default __webpack_public_path__ + "static/media/ao.78030d8c.basis";